import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AccordionModule } from 'primeng/accordion';
import { SliderModule } from 'primeng/slider';
import { TooltipModule } from 'primeng/tooltip';
import { NgxPaginationModule } from 'ngx-pagination';
import { RouterModule } from '@angular/router';
import { FilterPipe } from './pipe/filter.pipe';
import { CatSidebarComponent } from './components/cat-sidebar/cat-sidebar.component';
import { OrderTotalComponent } from './components/order-total/order-total.component';
import { FooterComponent } from './components/footer/footer.component';
import { JumbotronComponent } from './components/jumbotron/jumbotron.component';
import { BarRatingModule } from 'ngx-bar-rating';
import { GridViewComponent } from './components/grid-view/grid-view.component';
import { ListViewComponent } from './components/list-view/list-view.component';
import { HomeComponent } from '../home/home.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';

@NgModule({
  declarations: [
    FilterPipe,
    CatSidebarComponent,
    OrderTotalComponent,
    FooterComponent,
    JumbotronComponent,
    ListViewComponent,
    GridViewComponent,
    HomeComponent
  ],
  imports: [
    CommonModule,
    AccordionModule,
    SliderModule,
    TooltipModule,
    NgxPaginationModule,
    RouterModule,
    FormsModule,
    BarRatingModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule
  ],
  exports: [
    AccordionModule,
    TooltipModule,
    NgxPaginationModule,
    RouterModule,
    FilterPipe,
    SliderModule,
    FooterComponent,
    CatSidebarComponent,
    FormsModule,
    OrderTotalComponent,
    BarRatingModule,
    ListViewComponent,
    GridViewComponent,
    HomeComponent
  ],
})
export class SharedModule { }
